"use client";

import { cn } from "@workspace/ui/lib/utils";
import { ReactNode } from "react";

type NavContainerProps = {
  children: ReactNode;
  className?: string;
};

export function NavContainer({ children, className }: NavContainerProps) {
  return (
    <nav
      className={cn(
        "relative block z-50 pt-6 px-6 max-w-2xl mx-auto",
        className
      )}
    >
      <div className="backdrop-blur-xl rounded-full border border-neutral-100 px-8 py-2 shadow-xs bg-neutral-50/50">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          {children}
        </div>
      </div>
    </nav>
  );
}
